export interface ILayoutState {
  isVisible: boolean;
  mode: EWidgetMode;
  isModal: boolean;
  status: EWidgetStatus;
  amountError: string | null;
  widgetError: string | null;
}

export enum EWidgetMode {
  Deposit = 'deposit',
  Payment = 'payment',
}

export enum EWidgetStatus {
  /** Начальное состояние, в хранилище нет данных */
  Initial = 'initial',
  /** Данные загрузились, виджет отображается */
  Ready = 'ready',
  /** Запуск виджета или оплаты привязанной картой */
  Loading = 'loading',
}
